<template>
  <div :class="$style.container">
    <apexchart
      width="100%"
      height="210"
      type="donut"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div v-if="title" :class="$style.title">{{ title }}</div>
  </div>
</template>

<script setup lang="ts">
import type { ApexOptions } from 'apexcharts';
import { reactive, watch } from 'vue';

const { labels, series, gradientColorsFrom, gradientColorsTo, title } = defineProps({
  labels: {
    type: Array<string>,
    required: true,
  },
  series: {
    type: Array,
    required: true,
  },
  gradientColorsFrom: {
    type: Array,
    required: true,
  },
  gradientColorsTo: {
    type: Array,
    required: true,
  },
  title: {
    type: String,
    required: false,
    default: '',
  },
});

const chartOptions = reactive({
  title: {
    text: '',
  },
  colors: gradientColorsFrom,
  dataLabels: {
    enabled: false,
  },
  states: {
    hover: {
      filter: {
        type: 'none', // Disable any changes on hover
      },
    },
    active: {
      filter: {
        type: 'none', // Disable any changes on click
      },
    },
  },
  fill: {
    type: 'gradient',
    gradient: {
      shade: 'light',
      shadeIntensity: 0.5,
      gradientToColors: gradientColorsTo,
      opacityFrom: 0.7,
      opacityTo: 1,
      type: 'diagonal1',
      stops: [0, 100],
    },
  },
  legend: {
    show: false,
  },
  chart: {
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  labels: labels,
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 200,
        },
        legend: {
          position: 'bottom',
        },
      },
    },
  ],
} as ApexOptions);

defineExpose({ chartOptions });

watch(
  () => labels,
  (newLabels: string[]) => {
    chartOptions.labels = newLabels;
  },
);
</script>

<style lang="scss" module>
@import '@/assets/variables';

.container {
  width: 100%;
  padding-top: 0;
  padding-bottom: $space-100;
}

.title {
  margin-top: 0;
  margin-bottom: $space-50;
  text-align: center;
}
</style>
